import { render } from "./NoProducts.vue?vue&type=template&id=79fb2cc4&scoped=true"
const script = {}

import "./NoProducts.vue?vue&type=style&index=0&id=79fb2cc4&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79fb2cc4"]])

export default __exports__